module.exports = __webpack_public_path__ + "img/map-31d045.png";